import { Box, Grid, Stack, Typography } from '@mui/material';

import { getFileTypeIconFromApi } from '../../assets/utils/getFileTypeIconFromApi';

interface FileFromReportDetailsProps {
  id: number,
  fileType: string,
  originalFileName: string
}

interface AttachmentsProps {
  files: FileFromReportDetailsProps[]
}

const Attachments = ({ files }: AttachmentsProps) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk',
          fontSize: '0.875rem',
          fontWeight: 500,
          lineHeight: '0.875rem',
          mb: '0.6rem',
        }}
      >
        Attachments
      </Typography>
      <Grid container rowSpacing={0.9}>
        {files.length > 0 && files.map((file, id) => (
          <Grid
            item
            xs={12}
            key={id}
            style={{ listStyleType: 'none', paddingLeft: 0 }}
          >
            <Stack direction="row">
              {getFileTypeIconFromApi(file.fileType)}
              <Typography
                sx={{
                  ml: '0.4rem',
                  width: '100%',
                  textOverflow: 'ellipsis',
                  color: '#000000B2',
                  top: '0.25rem',
                  position: 'relative',
                  fontSize: '0.875rem',
                }}
                variant="body2"
              >
                {file.originalFileName}
              </Typography>
            </Stack>
          </Grid>
        ))}
        {files.length === 0 && 
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk',
          fontSize: '0.75rem',
          fontWeight: 500,
          lineHeight: '0.875rem',
          mb: '0.6rem',
          fontStyle: 'italic',
        }}
      >
        None
      </Typography>}
      </Grid>
    </Box>
  );
};

export default Attachments;
